"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createElement_1 = require("../../utils/dom/createElement");
class TrackDropdownService {
    constructor(dropdownService) {
        this.dropdownService = dropdownService;
        this.currentDropdownButton = null;
    }
    openDropdown(id, deleteCallback, openModalCallback, isPlaylist) {
        const trackItemElement = document.getElementById(`track-item-${id}`);
        if (!trackItemElement) {
            throw new Error(`Could not find the track with id: ${id}`);
        }
        const dropdownContainer = trackItemElement.querySelector('.tracks__item__drop');
        if (!(dropdownContainer instanceof HTMLElement)) {
            throw new Error('Dropdown container is not an instanceof HTMLElement');
        }
        this.addDropdown(dropdownContainer, trackItemElement, deleteCallback, openModalCallback, isPlaylist);
    }
    addDropdown(dropdownContainer, trackItemElement, deleteCallback, openModalCallback, isPlaylist) {
        var _a;
        const dropdownElement = this.createDropdownElement(isPlaylist);
        this.currentDropdownButton = trackItemElement.querySelector('.track__btn-dropdown');
        (_a = this.currentDropdownButton) === null || _a === void 0 ? void 0 : _a.classList.add('btn-dropdown--active');
        const dropdown = this.dropdownService.openDropdown(dropdownContainer, dropdownElement, () => {
            var _a;
            (_a = this.currentDropdownButton) === null || _a === void 0 ? void 0 : _a.classList.remove('btn-dropdown--active');
        });
        if (dropdown) {
            const addButton = dropdownElement.querySelector('.track__add-btn');
            addButton === null || addButton === void 0 ? void 0 : addButton.addEventListener('click', () => {
                openModalCallback();
            });
            const deleteButton = dropdownElement.querySelector('.track__delete-btn');
            deleteButton === null || deleteButton === void 0 ? void 0 : deleteButton.addEventListener('click', () => deleteCallback());
        }
        else {
            dropdownElement.remove();
        }
    }
    createDropdownElement(isPlaylist) {
        return (0, createElement_1.createElement)(`
      <div class="track__dropdown dropdown--active">
        <button class="track__add-btn">Добавить в плейлист</button>
        ${isPlaylist ? '<button class="track__delete-btn">Удалить из плейлиста</button>' : ''}
      </div>
      `);
    }
}
exports.default = TrackDropdownService;
